import {
  type IRadioCardOption,
  RadioCardGroupInput,
} from '@framework/form/inputs/card-group/RadioCardGroupInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { WidgetConfigurationSubCard } from '@framework/ui/components/configuration-card/widget/WidgetConfigurationSubCard.tsx';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { IconCategory } from '@tabler/icons-react';

export interface ICommonKindInputConfigProps {
  /** Opzioni disponibili per il tipo di campo. */
  kindOptions: IRadioCardOption[];
}

/**
 * Sub-card "Tipo di campo" nella card Impostazioni generali, condivisa dai
 * widget che supportano la selezione del tipo di input tramite card (Text,
 * SingleSelect, MultiSelect). Il FormItem tiene la label solo per gli screen
 * reader (`hideVisualLabel`): il titolo visivo è quello della sub-card.
 */
export function CommonKindInputConfig(props: ICommonKindInputConfigProps) {
  return (
    <WidgetConfigurationSubCard
      icon={<TbIcon icon={IconCategory} />}
      title="Tipo di campo"
      description="Modalità di resa del campo per chi compila."
    >
      <FormItem
        name="kind"
        label="Tipo di campo"
        layout={{ hideVisualLabel: true, removeMargin: true }}
      >
        <RadioCardGroupInput
          name="kind"
          options={props.kindOptions}
          noLabelOffset
        />
      </FormItem>
    </WidgetConfigurationSubCard>
  );
}
